
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import arrow from '../../assets/icons/e-learning/arrow.svg'
import edit from '../../assets/icons/e-learning/edit.svg'
import add from '../../assets/icons/e-learning/add.svg'
import edit_green from '../../assets/icons/e-learning/edit_green.svg'
import delete_icon from '../../assets/icons/e-learning/delete.svg'
import ModalAddCategory, { ModalEditCategory } from '../../components/modal/ModalAddCategory';
import * as api from '../services/api'
import Loader from '../../components/Loader'
import styles from './elearning.module.css'
import noData from '../../assets/images/noData.svg'
import { display } from '@mui/system';

function AllCategories() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [toggle, setToggle] = React.useState({})

    const [openModalAddCategory, setOpenModalAddCategory] = useState(false)
    const [openModalEditCategory, setOpenModalEditCategory] = useState(false)

    const [courseGroup, setCourseGroup] = useState([])
    const [courseList, setCourseList] = useState([])
    const [courseAll, setCourseAll] = useState([])

    const [dataUpdate, setDataUpdate] = useState({})

    useEffect(() => {
        findCourseGroup()
    }, [])

    const toggleFunction = (id) => {
        setToggle({
            ...toggle,
            [id]: !toggle[id],
        });
    }

    const findCourseGroup = async () => {
        setLoading(true)
        let res = await api.findCourseGroup()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setCourseGroup(res['data']['data'])
                findCourse(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findCourse = async (coursegroup) => {
        setLoading(true)
        let res = await api.findCourse()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setCourseList(res['data']['data'])

                let data = res['data']['data']
                let list = coursegroup.map((group) => ({
                    ...group,
                    List: data.filter((item) => item.e_learning_group_code === group.e_learning_group_code),
                }));
                setCourseAll(list.sort((a, b) => new Date(b.created_date) - new Date(a.created_date)))
                console.log(list)

            } else if(res['data']['code'] === 999) {
                let list = coursegroup.map((group) => ({
                    ...group,
                    List: []
                }));
                setCourseAll(list.sort((a, b) => new Date(b.created_date) - new Date(a.created_date)))
                console.log(list)
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const deleteCourse = async (code) => {
        setLoading(true)
        let res = await api.deleteCourse(code)
        setLoading(false)
        if (res) {
            if (res['data']['code']) {
                findCourseGroup()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const clickDeleteCource = (eLearningCode) => {
        // console.log(eLearningCode)
        deleteCourse(eLearningCode)
    }


    return (
        <>
            <Loader loading={loading} />
            {openModalAddCategory ?
                <ModalAddCategory
                    onClose={() => { setOpenModalAddCategory(false) }}
                    onSubmit={() => { findCourseGroup() }}
                />
                : null
            }
            {openModalEditCategory ?
                <ModalEditCategory
                    onClose={() => { setOpenModalEditCategory(false) }}
                    onSubmit={() => { findCourseGroup() }}
                    data={dataUpdate}
                />
                : null
            }


            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageELearning') }}
                    >กลับไป จัดการห้องเรียนออนไลน์</Box>
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    "@media (max-width: 800px)": {
                        display: 'grid',
                        justifyContent: 'center'
                    }
                }}>
                    <Box sx={{
                        fontWeight: 600,
                        color: "#478F96",
                        "@media (max-width: 800px)": {
                            textAlign: "center",
                        },
                    }}>รายการหมวดหมู่ทั้งหมด</Box>
                    <Button variant='contained' onClick={() => { setOpenModalAddCategory(true) }}>เพิ่มหมวดหมู่</Button>
                </Box>


                {courseAll.length > 0 ?
                    <React.Fragment>
                        {courseAll.map((item, index) => (
                            <Box sx={{
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                overflow: 'auto',
                                padding: '10px',
                                "@media (max-width: 800px)": {
                                    margin: '0px',
                                    padding: '5px',
                                }
                            }} key={index}>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    "@media (max-width: 800px)": {
                                        display: 'grid',
                                        justifyContent: 'center'
                                    }
                                }}>
                                    <Box sx={{ fontWeight: 600 }}>{item['e_learning_group_name']}</Box>
                                    <Box sx={{
                                        display: 'flex',
                                        gridGap: '10px',
                                    }}>
                                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                            <Button
                                                variant='contained'
                                                sx={{
                                                    display: 'flex',
                                                    gridGap: '5px',
                                                    "@media (max-width: 500px)": {
                                                        padding: '2px',
                                                    }
                                                }}
                                                onClick={() => {
                                                    setOpenModalEditCategory(true)
                                                    setDataUpdate(item)
                                                }}
                                            >
                                                <img src={edit} className={styles.img} />
                                                <Box>แก้ไขหมวดหมู่</Box>
                                            </Button>
                                            <Button
                                                variant='contained'
                                                sx={{
                                                    display: 'flex',
                                                    gridGap: '5px',
                                                    "@media (max-width: 500px)": {
                                                        padding: '2px',
                                                    }
                                                }}
                                                onClick={() => { navigate('/addCourse', { state: { group_code: item['e_learning_group_code'], button: "1" } }) }}
                                            >
                                                <img src={add} className={styles.img} />
                                                <Box>เพิ่มหลักสูตร</Box>
                                            </Button>
                                        </Box>
                                        <img
                                            className={toggle[index] === true ? styles.rotate180 : styles.rotate}
                                            src={arrow}
                                            onClick={() => { toggleFunction(index) }}
                                        />
                                    </Box>
                                </Box>
                                {toggle[index] ?
                                    <TableContainer sx={{ marginTop: '10px' }}>
                                        {item['List'].length > 0 ?
                                            <Table sx={{ minWidth: '800px' }}>
                                                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                                                    <TableRow>
                                                        <TableCell align='center' sx={{ width: '100px' }}>ลำดับ</TableCell>
                                                        <TableCell>ชื่อหลักสูตร</TableCell>
                                                        <TableCell align='center' sx={{ width: '120px' }}>จำนวนบทเรียน</TableCell>
                                                        <TableCell align='center' sx={{ width: '120px' }}>จำนวนชั่วโมง</TableCell>
                                                        <TableCell sx={{ width: '100px' }}></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {item['List'].sort((a, b) => new Date(b.created_date) - new Date(a.created_date)).map((i, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell align='center'>{idx + 1}</TableCell>
                                                            <TableCell>{i['e_learning_name']}</TableCell>
                                                            <TableCell align='center'>{i['properties'].length}</TableCell>
                                                            <TableCell align='center'>{i['e_learning_hour']}</TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', gridGap: '10px', justifyContent: 'center' }}>
                                                                    <img src={edit_green} style={{ cursor: 'pointer' }} onClick={() => { navigate('/editCourse', { state: { item: item['List'][idx], button: "1" } }) }} />
                                                                    <img src={delete_icon} style={{ cursor: 'pointer' }} onClick={() => { clickDeleteCource(i['e_learning_code']) }} />
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            :
                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Typography sx={{ fontSize: 18 }}>ไม่พบข้อมูล</Typography>
                                            </Box>
                                        }
                                    </TableContainer>
                                    : null
                                }
                            </Box>
                        ))}
                    </React.Fragment>
                    :
                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        overflow: 'auto',
                        padding: '30px',
                        "@media (max-width: 800px)": {
                            margin: '0px',
                            padding: '15px',
                        }
                    }}>
                        <Box sx={{ display: 'grid', justifyItems: 'center' }}>
                            <Typography sx={{ fontWeight: 600, color: '#478F96' }}>ไม่พบข้อมูล</Typography>
                            <img className={styles.noData} src={noData} />
                        </Box>
                    </Box>
                }
            </Box >
        </>
    )
}

export default AllCategories